export default __webpack_public_path__ + "static/media/logo.444663cd.png";